goog.provide('el8.appchart.letters.main');

goog.require('el8.app.shared.network.viewEditConnection');
goog.require('el8.appchart.dialog.saveTemplate');
goog.require('el8.uiwidget.confirm');
goog.require('el8.appchart.letters.faxGuide');
goog.require('el8.appchart.letters.form');
goog.require('el8.appchart.letters.rawFaxNag');
goog.require('el8.appchart.letters.selectAttachments');
goog.require('el8.appchart.letters.selectRelatedNote');
goog.require('el8.appchart.letters.templates');
goog.require('el8.appchart.showItemDetail');
goog.require('el8.appservice.notifier');
goog.require('el8.appshared.dialog.inviteToPassport');
goog.require('el8.data.educationalHandouts');
goog.require('el8.data.physicians');
goog.require('el8.data.practiceUsers');
goog.require('el8.model.AjaxQueue');
goog.require('el8.practicedata.letterTemplates');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.ptRefpanelGrant');
goog.require('el8.ptdata.ptRegistrationInfo');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.letters');
goog.require('el8.template.appshared.docTags');
goog.require('el8.template.mindreader');
goog.require('el8.template.ptdata.letters.attachments');
goog.require('el8.uiwidget.Dipdown');
goog.require('el8.util.consts');
goog.require('el8.util.smart');
goog.require('el8.util.validate');
goog.require('el8.util.amplitude.letterHelpers');

/**
 * This file controls the Letter pane used to compose new Letters to either
 * consultants or patients. It's a client of the thirdpane mgr.
 */
el8.appchart.letters.main = (function() {

    var that = {};

    var container = $('#third-pane-container');

    var content = null;
    var form = null;
    var curLetter = null;
    var Q = null; // AjaxQueue
    var totalPageCount = 0;

    /**
     * This is the external interface for the letter pane
     */
    $.extend(that, {

        show: function(spec) {
            var isSendToPatient = (spec.letter) ?
                spec.letter.isSendToPatient() : (spec.type === el8.util.consts.PATIENT_LETTER);
            var isReferralLetter = (spec.letter) ?
                spec.letter.isReferralLetter() : (spec.type === el8.util.consts.REFERRAL_LETTER);

            var showBehalfPhysicians = isReferralLetter && el8.data.currUser.isOfficeStaff();
            var referralDelegatingPhysicianIds = null;
            var behalfPhysicianList = [];

            that._autoAddToCareTeam = spec.autoAddToCareTeam;

            // if we are showing the list of physicians a staff can send on behalf of, we need to fetch the list sync
            // to avoid the race condition when the buttons are updated
            if (showBehalfPhysicians) {
                var physicians = el8.data.practiceUsers.getPhysicianUsersInWorkspace(false);

                referralDelegatingPhysicianIds = el8.data.currUser.getDelegatingPhysicianIdsMap().referrals;

                behalfPhysicianList = physicians.map(function(phy) {
                    return {
                        staffId: phy.staffId,
                        name: phy.fullName,
                        allowStaffToSendReferrals: referralDelegatingPhysicianIds.includes(phy.id)
                    };
                });
                behalfPhysicianList.forEach(function(item, idx){
                    if (item.staffId === el8.data.practiceUsers.getById(el8.ptdata.currPatient.getPrimaryPhysicianUserId()).getStaffId()){
                        behalfPhysicianList.splice(idx, 1);
                        behalfPhysicianList.unshift(item);
                    }
                });
            }

            container.append(el8.template.appchart.letters.content({
                isSendToPatient: isSendToPatient,
                patient: el8.ptdata.currPatient.asSoyMap(),
                referralAuths: el8.data.referralAuths,
                isReferralLetter: isReferralLetter,
                showBehalfPhysicians: showBehalfPhysicians,
                behalfPhysicians: behalfPhysicianList
            }));
            content = $('.third-pane-content', container);

            // by default, we allow signing
            var allowSigning = true;
            if (showBehalfPhysicians) {
                // we disable signing only if a staff is writing a referral but no doctor in the practice has allowed
                // the current user to sign referrals
                allowSigning = Boolean(referralDelegatingPhysicianIds && referralDelegatingPhysicianIds.length > 0);
            }

            form = el8.appchart.letters.form.create({
                'isSendToPatient': isSendToPatient,
                'newContactCb': newContactCb,
                'deleteLetterFn': deleteLetterFn,
                'isReferralLetter': isReferralLetter,
                'unreadAlertInDaysChangeFn': onUnreadAlertInDaysChange,
                'allowSigning': allowSigning
            });
            Q = new el8.model.AjaxQueue();

            // Store the data for the physician list, used for referrals
            form.behalfPhysicianList = behalfPhysicianList;

            // if we've already loaded letterTemplates, this will just call createMenu
            el8.practicedata.letterTemplates.softLoad(function() {
                el8.appchart.letters.templates.createMenu(content);
            }, true);

            el8.data.printHeaders.softLoad(function() {
                el8.appchart.letters.form.populatePrintHeaders(content);
            }, true);

            container.show();
            form.render();
            bindTriggers({isSendToPatient: true}); // bind triggers after rendering form

            createCurLetter(spec);
            form.setOptionCheckboxVal('includeAttachments', curLetter.isFaxAttachments());

            populateDocTagsWithTooltips();

            if (spec.showFtue) { el8.appchart.letters.faxGuide.start(); }
        },

        close: function() {
            that.extractLetter();
            saveLetter(false); //update display in req-act
            hide();
        },

        // this wraps replaceAttachments, when the caller just wants to add something new
        addAttachments: function(spec) {
            var newIds;
            if (spec.attachmentId) {
                newIds = [spec.attachmentId];
            } else {
                newIds = spec.attachmentIds || [];
            }
            var existingAttachments = curLetter.getAttachments().map(function(a) { return a.getAttachmentKey(); });
            newIds = _.reject(newIds, function(id) { return _.contains(existingAttachments, id); });

            var newItems = newIds.map(function(id) {
                if (_.contains(el8.data.attachablePrintouts, id)) {
                    return el8.ptdata.letters.createLetterAttachment({ printoutName: id });
                }
                return el8.ptdata.letters.createLetterAttachment({ entityId: id });
            });
            var allAttachments = newItems.concat(curLetter.getAttachments());

            allAttachments.sort(
                function(a, b) {
                    if (!a.getEntityDate() && !b.getEntityDate()) {
                        return 0; // Neither have dates - they're both printouts
                    }
                    else if (!a.getEntityDate && b.getEntityDate()) {
                        return 1; // Sort printouts 'before'
                    }
                    else if (a.getEntityDate && !b.getEntityDate()) {
                        return -1; // Sort non-printouts 'after'
                    }
                    else {
                        // Both have dates - sort by date
                        return b.getEntityDate() - a.getEntityDate();
                    }
                }
            );

            // noRender is used when we're going to trigger a save/render anyways soon
            // doHighlight is used to highlight any new attachments; noRender invalidates the option
            if (spec.noRender) {
                curLetter.setAttachments(allAttachments);
            } else {
                var callbackFn = spec.doHighlight ?
                    function() { highlightAttachments(newIds); } : null;
                that.replaceAttachments(allAttachments, callbackFn);
            }
        },

        // this should be used when the caller knows the correct state for all attachments
        replaceAttachments: function(attachmentItems, callbackFn) {
            curLetter.setAttachments(attachmentItems || []);

            var $attachmentsList = $('.attachments-list', container);
            $attachmentsList.addClass('el8Loading');
            saveLetter(true, function() { // don't need to refresh req act
                renderAttachments();
                $attachmentsList.removeClass('el8Loading');
                if (callbackFn) { callbackFn(); }
            });
        },

        // set a consultant letter's recipient, only if there is no recipient yet
        setPhysicianId: function(contactId) {
            if (!curLetter || curLetter.isSendToPatient() || curLetter.getDisplayTo()) { return; }
            setLetterContact(contactId);
        },

        useLetterTemplate: function(templateId, noTrigger) {
            var template = el8.practicedata.letterTemplates.getById(templateId);
            if (template) { el8.appchart.letters.templates.useTemplate(template, noTrigger); }
        },

        // extract referral fields from the form
        extractReferralFields: function() {
            var r = curLetter.getReferralOrder();
            r.setAuthNumber(form.getVal('authNumber'));
            r.setAuthorizationForShort(form.getVal('authorizationFor'));

            var icdIds = form.getIcd10Listeditor('dxs-le').getIcdIdLists();
            r.setIcd9Codes([]);
            r.setIcd9Ids(icdIds.icd9Ids);
            r.setIcd10Ids(icdIds.icd10Ids);
        },

        // update curLetter based on the current contents of the pane
        extractLetter: function() {
            curLetter.setSubject(form.getVal('subject'));
            curLetter.setBody(form.getVal('body'));
            curLetter.setPrintHeaderId(form.getVal('printHeaderId'));

            // only set delivery date if it's a valid date; otherwise, clear the property in the model
            var deliveryDateStr = form.getVal('deliveryDate');
            var deliveryDate = el8.util.datecompare.dateFromStr(deliveryDateStr);
            if (!deliveryDate || !el8.util.datecompare.isAfterToday(deliveryDate)) {
                curLetter.setDeliveryDate(null);
            } else {
                curLetter.setDeliveryDate(deliveryDateStr);
            }

            // sync up the unread alerts
            var unreadAlertInDaysStr = form.getVal('unreadAlertInDays');
            if (isAlertBySpecificDate(unreadAlertInDaysStr)) {
                // use a date
                // only set unreadAlertDate date if it's a valid date; otherwise, clear the property in the model
                var unreadAlertDateStr = form.getVal('unreadAlertDate');
                var unreadAlertDate = el8.util.datecompare.dateFromStr(unreadAlertDateStr);
                if (!unreadAlertDate || !el8.util.datecompare.isAfterToday(unreadAlertDate)) {
                    curLetter.setUnreadAlertInDays(null);
                    curLetter.setUnreadAlertDate(null);
                } else {
                    curLetter.setUnreadAlertDate(unreadAlertDateStr);
                    curLetter.setSignedUnreadAlertDate(unreadAlertDateStr);
                }
                curLetter.setUnreadAlertInDays(null);
            } else if (isAlertDisabled(unreadAlertInDaysStr)) {
                // disabled (dont notify me)
                curLetter.disableUnreadNotification();
            } else {
                // in days
                curLetter.setUnreadAlertDate(null);
                curLetter.setUnreadAlertInDays(unreadAlertInDaysStr);
                curLetter.setSignedUnreadAlertDate(getCurrentAlertNotificationDate());
            }

            // chart exports
            var reallyBigLetter = (totalPageCount >= el8.util.consts.EL8_DOWNLOAD_ONLY_PAGES);
            curLetter.setWithArchive(reallyBigLetter);

            if (curLetter.isSendToPatient()) { return curLetter; } // none of this recipient stuff will apply

            // extract recipient
            var toFieldStr = form.getVal('toField');
            var toFieldObj = form.getClickItemSelected('toField');

            if (toFieldObj) {
                curLetter.setRecipient('sendToContactId', toFieldObj.id);
            } else if (el8.util.smart.isPhoneNum(toFieldStr)) {
                curLetter.setRecipient('faxTo', toFieldStr);
            } else {
                curLetter.setRecipient('sendToName', toFieldStr);
            }

            // fax_attachments
            if (curLetter.getFaxTo()) {
                // we don't send passport invites to raw faxes
                curLetter.setFaxAttachments(true);
            } else if (totalPageCount > el8.util.consts.EL8_HI_FAX_PAGES || el8Globals.PASSPORT_EMR) {
                // too long to fax attachments or a free passport-emr account -> chop
                curLetter.setFaxAttachments(false);
            } else if ($('.fax-attachments-section', container).is(':visible')) {
                curLetter.setFaxAttachments(form.getOptionCheckboxVal('includeAttachments'));
            }

            // referral fields
            if (curLetter.isReferralLetter()) {
                that.extractReferralFields();
            }

            // if the user:
            // 1. left the subject line blank and keep the default body verbiage or
            // 2. left the subject line blank and cleared the default body
            // don't print or fax the 1st "cover page" of the letter
            var defaultFaxBody = el8.template.appchart.letters.defaultFaxBody();
            var defaultDirectMessageBody = el8.template.appchart.letters.defaultDirectMessageBody();
            var body = curLetter.getBody();
            curLetter.setSkipCoverPage(false);

            if (curLetter.getSubject() === "") {
                if (body === defaultFaxBody || body === defaultDirectMessageBody || body.trim() === '') {
                    // Note: for fax letters with the default body injected or a known provider
                    // with an empty body this is the default state of curLetter once textChangeFn
                    // fires.
                    //
                    // If we're skipping the cover page, clear out any default body copy
                    curLetter.setBody('');
                    curLetter.setSkipCoverPage(true);
                }
            }

            return curLetter;
        },

        signLetter: function(spec) {
            spec = spec || {};
            curLetter.setSignDate(el8.service.tz.now());
            var extraArgs = spec.extraArgs || {};
            if (el8Globals.FEATURES.ProvidersNetwork) {
                extraArgs['add_to_main_providers'] = form.getVal('addToMainProviders');
            }
            if (el8Globals.FEATURES.PLR4Everyone) {
                if (el8.data.currUser.isPhysician() && el8.data.currPractice.isPracticingEmr()) {
                    extraArgs['add_to_care_team'] = form.getVal('addToCareTeam');
                    extraArgs['add_to_main_providers'] = false;
                } else {
                    extraArgs['add_to_care_team'] = false;
                    extraArgs['add_to_main_providers'] = false;
                }
            }
            if (curLetter.isSendToPatient()) {
                // in addition to looking at the closeThread checkbox, patient letters to uninvited patients
                // (printed, rather than passport delivered) should be default closed
                extraArgs['close_thread'] =
                    (form.getOptionCheckboxVal('closeThread') || curLetter.getDeliveryMethod() === 'printed');
            }
            if (curLetter.isReferralLetter() && el8.data.currUser.isOfficeStaff() && form.getVal('onBehalfOf')) {
                extraArgs['on_behalf_of_physician_id'] = form.getVal('onBehalfOf');
            }

            var el8AjaxArgs = el8.ptdata.letters.saveAjaxArgs(curLetter, false, {
                async: (spec.async !== false), //default to async
                successCb: function(updatedLetter) {
                    if (spec.callbackFn) { spec.callbackFn(updatedLetter); }

                    var reminderLetter;
                    if (spec.draftReminder) {
                        reminderLetter = el8.ptdata.letters.createReminderVersion(curLetter);
                    }
                    hide();

                    if (updatedLetter.isReferralLetter()) {
                        // add a short delay so the user can see the letter close
                        _.delay(function() { linkReferralToUnsignedNote(updatedLetter); }, 500);
                    } else {
                        // don't reference Letter model if this is a Referral Letter, because
                        // we've asked the user if they want to make the Order an owned order
                        el8.appchart.mgr.notes.addNewLetter(updatedLetter);
                    }

                    if (reminderLetter) {
                        // false = noNotify - we want this in reqAct
                        var el8AjaxArgs = el8.ptdata.letters.saveAjaxArgs(reminderLetter, false, {
                            successCb: function() {
                                el8.appservice.notifier.notify('Your original letter has been signed. Displaying your reminder letter...');
                                // add a short delay so the user can see the old letter close
                                _.delay(function() {
                                    el8.appchart.mgr.thirdpane.showLetter({ letter: reminderLetter });
                                    // log manually that a new letter was created
                                    el8.util.amplitude.logStartLetter('Reminder', reminderLetter.getLetterType());
                                }, 1000);
                            }
                        });
                        $.el8_ajax(el8AjaxArgs);
                    }
                },
                extraArgs: extraArgs
            });
            Q.doFinalAjax(el8AjaxArgs);
        },

        getCurrentLetter: function() {
            if (!curLetter) { return null; }
            return curLetter;
        },

        getLetterType: function() {
            if (!curLetter) { return null; }
            return curLetter.getLetterType();
        },

        getDeliveryType: function() { return curLetter.getDeliveryMethod(); },

        getPageCount: function() { return totalPageCount; },
        getForm: function() { return form; }

    });



    /* ---------------------------------------------------------------------
     * Internal functions
     * --------------------------------------------------------------------- */

    /**
     * Functions to setup/destroy the pane
     */
    // close() is an external function which saves the letter and then hides the pane.
    // hide() is an internal function that just hides/destroys the pane.
    function hide() {
        destroyDocTagTooltips();
        container.empty().hide();
        el8.appchart.mgr.thirdpane.hidePane();
        el8.ptdata.ptRefpanelGrant.unbind('all', updatePtAttachNotice);
        el8.ptdata.ptRegistrationInfo.unbind('all', updatePtRegistrationInfo);
        el8.appchart.letters.templates.destroyMenu();
        el8.appchart.letters.rawFaxNag.destroy();
        el8.appchart.letters.faxGuide.end();

        content = null;
        form = null;
        curLetter = null;
        Q = null;
        totalPageCount = 0;
    }
    function deleteLetterFn() {
        var curLetter = that.extractLetter();
        Q.abortQueue();
        el8.ptdata.letters.deleteItem(curLetter);
        hide();
    }

    function onPostDateChange() {
        el8.appchart.letters.form.updateButtons(form, curLetter);
        syncUnreadNotificationUIState();
        alertIfPostDateAndAlertDateConflict();
    }

    function onUnreadAlertInDaysChange() {
        syncUnreadNotificationUIState();
        alertIfPostDateAndAlertDateConflict();
    }

    function populateDocTagsWithTooltips() {
        var docTagMaps = curLetter.getDocTagMaps();
        if (docTagMaps) {
            $('.doctags', form._container).html(
                el8.template.appshared.docTags.docTagsLine({
                    docTags: curLetter.getDocTagMaps()
                })
            );

            el8.appshared.docTags.tooltips.create(form._container, curLetter);
        }
    }

    function destroyDocTagTooltips() {
        _(form._container.find('.doctag-coded.has-tippy')).each(function (span) {
            el8.appshared.docTags.tooltips.destroy(span);
        });
    }

    function bindTriggers(spec) {

        var isSendToPatient = spec ? spec.isSendToPatient : false;

        var textChangeFn = function() {
            if (!curLetter) { return; }
            // because this is debounced, it might run after signLetter has finalized the AjaxQueue
            if (Q.isFinalized()) { return; }
            // only need to re-render delivery types for contact changes
            var toFieldChanged = ($(this).attr('name') === 'toField');
            var postDateChanged = ($(this).attr('name') === 'deliveryDate');
            var unreadAlertDateChanged = ($(this).attr('name') === 'unreadAlertDate');
            that.extractLetter();
            saveLetter(true, function() {
                if (!curLetter) { return; }
                if (toFieldChanged) { onToFieldChange(); }
                if (postDateChanged) { onPostDateChange(); }
                if (unreadAlertDateChanged) { alertIfPostDateAndAlertDateConflict(); }
            }); //don't need to update reqact
        };
        // Sometimes we programatically change the textarea repeatedly and we
        // don't want to repeatedly POST for each one; 50ms is too fast for ppl.
        // The auto-save exists for non-textarea inputs that we want to save on blur
        content.on('change', 'textarea, .auto-save',  _.debounce(textChangeFn, 50));

        if (el8Globals.FEATURES.PLR4Everyone) {
            // when we toggle "Add to care team", we also update whether we show the prompt
            // to remind user to toggle their auto share settings
            content.on('change', 'input[name="addToCareTeam"]',  function() {
                that.updatePlrSharingPrompt();
            });
        }

        content.on('click', '.attach-items',  function() {
            el8.appchart.letters.selectAttachments.show({
                callbackFn: that.replaceAttachments,
                attachments: curLetter.getAttachments(),
                isPassport: curLetter.isSendToPatient()
            });
        });
        content.on('click', '.export-chart',  function() {

            el8.uiwidget.confirm(
                'Would you like to attach all documents in patient chart to this letter?',
                function() {
                    el8.appservice.notifier.notify('Preparing chart export... This may take some time.');
                    var $this = $(this);

                    $('.attachments-loading-holder', container).addClass('el8ShortLoading');
                    $this.prop('disabled', true);
                    form.disable();
                    el8.appchart.letters.selectAttachments.getAllAttachments(
                        that.addAttachments,
                        function() {
                            saveLetter(true, function() {
                                $this.prop('disabled', false);
                                renderAttachments(); // make sure the final attachment count was right
                                $('.attachments-loading-holder', container).removeClass('el8ShortLoading');
                                form.enable();
                                updateActions();
                            });
                        }
                    );
                }
            );
        });
        content.on('click', '.add-edit-tags-trigger',  function () {
            el8.appchart.dialog.docTags.show({
                doc: curLetter,
                successCb: function() { populateDocTagsWithTooltips(); }
            });
            return false;
        });

        content.on('click', '.remove-attachment',  function() {
            if (!form.isEnabled()) { return; }
            var id = $(this).data('id');
            curLetter.deleteAttachment(id);
            saveLetter(true, function() { //don't need to update reqact
                renderAttachments();
            });
        });

        content.on('click', '.item-details-trigger',  function() {
            var id = $(this).data('id');
            if (el8.model.idToModelClass(id) === 'Handout') {
                el8.data.educationalHandouts.downloadById(id);
            } else {
                el8.appchart.showItemDetail(id);
            }
            return false;
        });

        content.on('click', '.template-menu-trigger',  function() {
            var actionsMenu = el8.appchart.letters.templates.getActionsMenu();
            var templateList = el8.appchart.letters.templates.getList();
            actionsMenu.display($(this), null, {top: 19, left: 20}, templateList);
            return false;
        });
        content.on('click', '.template-save-trigger',  function() {
            el8.appchart.letters.templates.saveFormAsTemplate();
        });

        content.on('click', '.invite-passport-trigger',  function() {
            el8.appshared.dialog.inviteToPassport.show();
        });

        content.on('click', '.start-sharing-letter-form-trigger',  function() {
            $.el8_ajax({
                type: 'POST',
                data: JSON.stringify({ sharing_enabled: true }),
                url: el8.service.urls.get('setCareTeamSharing'),
                success: function(data) {
                    el8.appservice.notifier.notify("You are now sharing records with this patient's Care Team.");
                    el8.ptdata.ptProviders.load();
                    el8.ptdata.careTeamProviders.load();
                    el8.appchart.providers.main.refreshPatientTeam();
                    $('.sharing-not-enabled-prompt').hide();
                }
            });
        });

        if (isSendToPatient && el8Globals.FEATURES.MUReports) {
            content.on('click', ':input[name="isPatientReminder"]',
                function() {
                    var typeVal = $(this).val();
                    curLetter.updateMeaningfulUseInfo({is_patient_reminder: (typeVal*1 === 1)});
                }
            );
            el8.uiwidget.collapsible({
                container: $('.mu-info-body', content),
                triggerElt: $('.mu-info-header', content),
                statusElt: $('.mu-info-status', content),
                isCollapsed: true,
                expandFn: function() { content.scrollTo('100%'); }
            });
        }

        /*
         * Update the form's action buttons when the user selects a different physician
         */
        content.on('change', '.behalf-physicians',  function() {
            el8.appchart.letters.form.updateButtons(form, curLetter);
        });

        setupIncludeAttachmentsCheckboxListener();
    }
    /* end pane setup */


    /**
     * Functions to modify data in the pane or its underlying letter
     */
    // called by show() to create curLetter and then render the initial attachment list
    function createCurLetter(spec) {
        var attachmentsToHighlight = null;

        if (spec.letter) {
            curLetter = spec.letter;
            renderFormFromLetter();
        } else {
            curLetter = el8.ptdata.letters.create({}, true); //we're going to cause a trigger at saveLetter
            curLetter.setLetterType(spec.type);

            // set the default notification alert setting from user setting
            setDefaultUnreadNotificationFromUserPreference(spec.type);

            if (spec.type !== el8.util.consts.PATIENT_LETTER) {
                curLetter.setRecipient('sendToPatient', false);

                /* Only allow populating of contact for consultant letters,
                 * need to set noTrigger=true, because otherwise this will trigger
                 * an async letter-saving, which will then create two dup letters. */
                if (spec.contactId) {
                    setLetterContact(spec.contactId, true);
                    form.focusField('subject');
                } else {
                    form.focusField('toField');
                }
                if (el8Globals.FEATURES.DefaultFaxAttach) {
                    curLetter.setFaxAttachments(true);
                }
            } else {
                curLetter.setRecipient('sendToPatient', true);
                if (el8.ptdata.ptRegistrationInfo.getInviteStatus() !== 'NOT_INVITED') {
                    // the server will set this soon, but if we do it now, the UI renders more smoothly
                    curLetter.setDeliveryMethod('passport');
                }
                renderPatientSections();
            }
            if (spec.templateId) { that.useLetterTemplate(spec.templateId, true); }

            // deal with referral letter fields
            if (spec.type === el8.util.consts.REFERRAL_LETTER) {
              curLetter.setAttachments([ //attach LHS and Pt Demog by default
                  el8.ptdata.letters.createLetterAttachment({ printoutName: el8.util.consts.REFPANEL_PSEUDO_CLASS }),
                  el8.ptdata.letters.createLetterAttachment({ printoutName: el8.util.consts.DEMOG_PSEUDO_CLASS })
              ]);
            }


            if (spec.attachmentId || spec.attachmentIds) {
                attachmentsToHighlight = spec.attachmentIds || [spec.attachmentId];
                // we don't want to render yet because we're going to do that below
                that.addAttachments($.extend({}, spec, { noRender: true} ));
            }
            if (spec.subject) {
                form.setVal('subject', spec.subject, true); //don't need to trigger extractLetter here
                curLetter.setSubject(spec.subject);
            }

            // only true if autoAddToCareTeam flag was set (via some "add to care team" UI link)
            if (el8Globals.FEATURES.PLR4Everyone && spec.autoAddToCareTeam) {
                var $addCareTeamCheckbox = $('.add-to-care-team-section', container);
                if (el8.ptdata.careTeamProviders.canCurrentUserGrantAccess()) {
                    $addCareTeamCheckbox.show();
                }
                form.setOptionCheckboxVal('addToCareTeam', true);
                that.updatePlrSharingPrompt();
            }

            saveLetter(false, onToFieldChange); //want new letter in reqact
            // there is an inherent assumption that we specify click source in the
            // spec for letter creation. Note we default to provider letter if type is not specified
            el8.util.amplitude.logStartLetter(spec.clickSource, spec.type || el8.util.consts.CONSULTANT_LETTER);
        }

        // signal to renderAttachments that were creating since we need to set the fax attachments
        // checkbox based on the DefaultFaxAttach feature flag
        renderAttachments(true);
        if (attachmentsToHighlight) { highlightAttachments(attachmentsToHighlight); }
    }

    // hides/shows the PLR sharing prompt based on if user has sharing enabled by default
    // also only shows if "add to care team is checked"
    that.updatePlrSharingPrompt = function() {
        if (form.getVal('addToCareTeam') &&
            !el8.ptdata.careTeamProviders.isUserSharing(el8.data.currUser.getId()) &&
            el8.ptdata.careTeamProviders.canCurrentUserGrantAccess()) {
            $('.sharing-not-enabled-prompt', content).show();
        } else {
            $('.sharing-not-enabled-prompt', content).hide();
        }
    };

    function setLetterContact(contactId, noTrigger) {
        curLetter.setRecipient('sendToContactId', contactId);
        renderContact(noTrigger);
    }

    // The callback handed to addEditContact - it handles an empty response (which
    // usually means either a deletion) or a new contact (by wrapping setLetterContact)
    function newContactCb(contactOrContactId) {
        el8.appchart.letters.rawFaxNag.hideIfShowing();
        if (!contactOrContactId) {
            form.getClickItem('toField').reset();
            form.getClickItem('toField').clearMindreaderCache();
            return;
        }
        setLetterContact(
            typeof contactOrContactId === 'number' 
            ? contactOrContactId
            : contactOrContactId.getId()
        );
    }

    function saveLetter(noNotify, callbackFn) {
        var extraArgs = {};
        if (curLetter.isReferralLetter() && el8.data.currUser.isOfficeStaff() && form.getVal('onBehalfOf')) {
            extraArgs['on_behalf_of_physician_id'] = form.getVal('onBehalfOf');
        }
        var el8AjaxArgs = el8.ptdata.letters.saveAjaxArgs(curLetter, noNotify, {
            successCb: callbackFn, // callbackFn takes item
            extraArgs: extraArgs
        });
        Q.doAjax('letter', el8AjaxArgs);
    }

    // Check if there are unsigned notes that we might want to link this
    // referral letter to and handle if so. We don't use curLetter because
    // the pane has already been hidden when this is called.
    function linkReferralToUnsignedNote(letter) {
        if (!letter.isReferralLetter()) { return; }

        var reqActNotes = el8.appchart.mainFeeds.reqAct.getIndex().filter(function(item) {
            return _.contains(['VisitNote', 'NonvisitNote'], item.model_class);
        });
        var reqActNoteIds = _.pluck(reqActNotes, 'id');

        var noteShowFn = function(noteId) {
            el8.appchart.mgr.notes.showNoteId({
                noteId: noteId,
                callbackFn: function() {
                    el8.appchart.mgr.notes.addNewOrder(letter.getReferralOrder());
                }
            });
        };

        if (reqActNoteIds.length === 1) {
            noteShowFn(reqActNoteIds[0]);
        } else if (reqActNoteIds.length > 1) {
            el8.appchart.letters.selectRelatedNote.show(reqActNoteIds, noteShowFn);
        }
    }

    // set/empty the letter body as appropriate
    function prefillLetterBody() {
        var body = form.getVal('body');
        var defaultFaxBody = el8.template.appchart.letters.defaultFaxBody();
        var defaultDirectMessageBody = el8.template.appchart.letters.defaultDirectMessageBody();
        var defaultAddToCareTeamBody = el8.template.appchart.letters.defaultAddToCareTeamBody();

        // if we don't trigger 'change' here manually, setVal doesn't fire it for some reason
        if ((curLetter.getDeliveryMethod() === 'fax' || curLetter.getDeliveryMethod() === 'passport')
                && curLetter.getSendToContactId()) {
            if (!body) {
                if (el8Globals.FEATURES.PLR4Everyone &&
                    form.getVal('addToCareTeam') && !form.isFieldEnabled('addToCareTeam')) {
                    var defaultAddToCareTeamBodyFax = el8.template.appchart.letters.defaultAddToCareTeamBodyFax();
                    form.setVal('body', defaultAddToCareTeamBodyFax);
                    form.getInputField('body').focusSelect().change();
                } else {
                    form.setVal('body', defaultFaxBody);
                    form.getInputField('body').focusSelect().change();
                }
            }
        } else if (curLetter.getDeliveryMethod() === 'direct') {
            // prepop this message ONLY if it's direct AND fax
            if (!body) {
                if (el8Globals.FEATURES.PLR4Everyone &&
                    form.getVal('addToCareTeam') && !form.isFieldEnabled('addToCareTeam')) {
                    // we don't prepopulate any care team specific message if it's for direct
                } else {
                    var contact = el8.data.physicians.getById(curLetter.getSendToContactId());
                    if (contact.getFax()) {
                        form.setVal('body', defaultDirectMessageBody);
                        form.getInputField('body').focusSelect().change();
                    }
                }
            }
        } else if (el8Globals.FEATURES.PLR4Everyone &&
                   form.getVal('addToCareTeam') && !form.isFieldEnabled('addToCareTeam')) {
            if (!body) {
                var defaultAddToCareTeamBody = el8.template.appchart.letters.defaultAddToCareTeamBody();
                form.setVal('body', defaultAddToCareTeamBody);
                form.getInputField('body').change();
            }
        } else if (body === defaultFaxBody || body === defaultDirectMessageBody || body === defaultAddToCareTeamBody) {
            form.setVal('body', '');
            form.getInputField('body').change();
        }

        // PLR-4-Everyone TODO: prepopulate defaultCareTeamInviteBody to message body
    }
    /* end data modifiers */


    /**
     * Functions to manage rendering details of the pane
     */

    // Populate an empty pane from a provided letter
    function renderFormFromLetter() {
        form.populate(curLetter.asSoyMap());
        var contactId = curLetter.getSendToContactId();
        var focusField = 'subject';
        if (curLetter.isSendToPatient()) {
            renderPatientSections();
            if (el8Globals.FEATURES.MUReports) {
                if (curLetter.getMeaningfulUseInfoItem('isPatientReminder')) {
                    $(':input[name="isPatientReminder"][value="1"]', content).prop('checked', true);
                } else {
                    $(':input[name="isPatientReminder"][value="0"]', content).prop('checked', true);
                }
            }
        } else {
            if (contactId) {
                renderContact(true);
            } else if (curLetter.getFaxTo()) {
                //noTrigger=true so we don't trigger an implicit save
                form.setVal('toField', curLetter.getFaxTo(), true);
            } else if (curLetter.getDisplayTo()) {
                form.setVal('toField', curLetter.getDisplayTo(), true);
            } else if (el8.appchart.layout.getViewMode() !== 'small') {
                // if we're in 2P made, we don't want to focus on the toField,
                // because while the pane is animating open, the toField mindreader
                // will be positioned off screen (hacky fix - it'd be better if
                // we could just do this after the animation ends)
                focusField = 'toField';
            }
        }

        // referral fields
        if (curLetter.isReferralLetter()) {
            var referralOrder = curLetter.getReferralOrder();

            // Repopulate the Dxs
            form.getIcd10Listeditor('dxs-le').repopulateFromIdLists({
                icd10Ids: referralOrder.getIcd10Ids(),
                icd9Ids: referralOrder.getIcd9Ids()
            }, true);

            form.setVal('authNumber', curLetter.getReferralOrder().getAuthNumber(), true);
            form.setVal('authorizationFor', curLetter.getReferralOrder().getAuthorizationForShort(), true);
        }
        setUnreadAlert();
        form.focusField(focusField);
    }

    function setUnreadAlert() {
        $('.unread-alert-date-picker').hide();
        if (curLetter.isUnreadAlertDisabled()) {
            form.setVal('unreadAlertInDays', 'none', true);
        } else {
            if (curLetter.getUnreadAlertInDays()) {
                form.setVal('unreadAlertInDays', curLetter.getUnreadAlertInDays(), true);
            } else {
                form.setVal('unreadAlertInDays', 'specificDate', true);
            }
        }
    }

    // We don't want to have to pass ptRegistrationInfo/ptRefpanelGrant
    // into the .content template all the time, so this function manages
    // a few patient specific form elements
    function renderPatientSections() {
        // update the notice about what the patient already has access to and keep it in sync
        el8.ptdata.ptRefpanelGrant.softLoad();
        updatePtRegistrationInfo();
        el8.ptdata.ptRefpanelGrant.bind('all', updatePtAttachNotice);
        el8.ptdata.ptRegistrationInfo.bind('all', updatePtRegistrationInfo);
    }
    // render the correct notice for what the patient currently has access to
    function updatePtAttachNotice() {
        if (el8.ptdata.ptRegistrationInfo.getInviteStatus() !== 'NOT_INVITED') {
            $('.pt-attachment-notice', container).html(
                el8.template.appchart.letters.patientAttachmentNotice(el8.ptdata.ptRefpanelGrant.asSoyMap())
            );
        }
    }
    // render the correct details
    function updatePtRegistrationInfo() {
        updateDeliveryDescription();
        if (el8.ptdata.ptRegistrationInfo.getInviteStatus() !== 'NOT_INVITED') {
            form.updateButtonCaption('sign-print', 'Sign, Send & Print');
        }
        updatePtAttachNotice();
    }

    // Used for consultant letters, when the contact is being externally set
    // (new contact created or opening a saved draft)
    function renderContact(noTrigger) {
        var contactId = curLetter.getSendToContactId();
        var contact = el8.data.physicians.getById(contactId);
        if (contact) {
            var name = contact.getFullName();
            var publicAccessUserInfo = contact.getPublicAccessUserInfo();
            var solrMap = {
                id: contactId,
                model_class: 'Physician',
                contact_type: contact.getContactType(),
                name: name,
                fax: contact.getFax(),
                access_practice_fax: contact.getAccessPracticeFax(),
                email: contact.getEmail(),
                direct_address: contact.getDirectAddress(),
                // important: use the public_access_user_id so we don't accidentally
                // let someone send Via Elation to a test account
                public_access_user_id: publicAccessUserInfo.public_access_user_id,
                provider_logo: publicAccessUserInfo.provider_logo
            };
            form.setClickItemSelected('toField', solrMap, noTrigger);
        }
    }

    function setDefaultUnreadNotificationFromUserPreference(letterType) {
        // use the user's preference to set letter's default notification
        if (el8.data.currUser.getUnreadLetterNotifications(letterType)) {
            curLetter.setUnreadAlertInDays(el8.data.currUser.getUnreadLetterNotifications(letterType));
        } else {
            curLetter.setUnreadAlertDisabled(true);
        }
    }

    function onToFieldChange() {
        setDefaultUnreadNotificationFromUserPreference(curLetter.getLetterType());
        renderToFieldTriggers();
        renderDeliveryDependentInfo();
        nagIfRawFax();
        updateFtueGuide();
    }

    function updateFtueGuide() {
        if (!el8.appchart.letters.faxGuide.isInProgress()) { return; }
        var toFieldItem = form.getClickItemSelected('toField');

        /* using toFieldItem instead of values from curLetter because sometimes this
         * gets triggered as the toField is in the process of changing, and the
         * actual mindreader/clickitem is more likely to return a contact id in that case */
        if (toFieldItem) {
            $(document).trigger('letter-chose-contact');
        } else if (form.getVal('toField')) {
            if (curLetter.getFaxTo()) { return; } // rawFaxNag will already be triggered
            $(document).trigger('letter-wrote-name');
        } else {
            el8.appchart.letters.faxGuide.start(); // blank toField: restart
        }
    }

    // Used for consultant letters to update the links / checkbox next to the field,
    // when the selected contact changes
    function renderToFieldTriggers() {
        var contactId = curLetter.getSendToContactId();
        var contact = el8.data.physicians.getById(contactId);
        // manually set recipient type on current letter if contact exists. Used for amplitude
        if (contactId && contact) { curLetter.setRecipientType(contact.getContactType()); }
        var toFieldVal = form.getVal('toField');
        var $addProviderTrig = $('.add-to-main-providers-section', container); // won't exist if ProviderNetwork is off
        var $addCareTeamTrig = $('.add-to-care-team-section', container);

        if (contactId || toFieldVal) {
            if (el8Globals.FEATURES.PLR4Everyone) {
                $addProviderTrig.hide();

                var canGrantAccess = contact && contact.isMapped();

                if (el8.ptdata.careTeamProviders.canCurrentUserGrantAccess() && canGrantAccess) {
                    $addCareTeamTrig.show();
                } else {
                    $addCareTeamTrig.hide();
                }
            } else {
                if (contactId) {
                    $addProviderTrig.show();
                } else {
                    $addProviderTrig.hide();
                }
                $addCareTeamTrig.hide();
            }
        } else {
            if (el8Globals.FEATURES.PLR4Everyone) {
                that.updatePlrSharingPrompt();
                $addProviderTrig.hide();
                if (el8.ptdata.careTeamProviders.canCurrentUserGrantAccess()) {
                    $addCareTeamTrig.show();
                } else {
                    $addCareTeamTrig.hide();
                }
            } else {
                $addProviderTrig.hide();
                $addCareTeamTrig.hide();
            }
        }
    }

    // Render details that show/hide depending on the selected delivery type
    function renderDeliveryDependentInfo() {
        updateDeliveryDescription();
        updateActions();
        if (!curLetter.isSendToPatient()) { prefillLetterBody(); }
        // log that we changed the recipient to amplitude
        el8.util.amplitude.logAddLetterRecipient(curLetter);
    }

    // update the header of the options pane, based on the current delivery method
    function updateDeliveryDescription() {
        var $optionsPaneHeader = $('.options-pane-header', container);
        $optionsPaneHeader.html(
            el8.template.appchart.letters.deliveryMethodList({
                letter: curLetter.asSoyMap(),
                recipient: form.getClickItemSelected('toField'),
                ptInviteStatus: el8.ptdata.ptRegistrationInfo.getInviteStatus(),
                pageCount: totalPageCount,
                FAX_PAGE_LIMIT: el8.util.consts.EL8_HI_FAX_PAGES,
                PDF_PAGE_LIMIT: el8.util.consts.EL8_DOWNLOAD_ONLY_PAGES
            })
        );

        // also update the subject disclaimer for direct message
        if (curLetter.getDeliveryMethod() === 'direct') {
            $("#directMessageSubjectDisclaimer").removeClass('hidden');
        }
        else {
            $("#directMessageSubjectDisclaimer").addClass('hidden');
        }

        syncIncludeAttachmentsCheckbox();
    }

    // updates whether buttons are enabled/disabled and faxAttachments checkbox is visible or not
    function updateActions() {
        // render the alert UI state
        setUnreadAlert();

        el8.appchart.letters.form.updateButtons(form, curLetter);

        var faxablePageCount = (totalPageCount <= el8.util.consts.EL8_HI_FAX_PAGES);
        if (!faxablePageCount) {
            form.disableButton('print-preview');
        } else {
            form.enableButton('print-preview');
        }
        if (curLetter.isSendToPatient()) { return; }

        var deliveryType = curLetter.getDeliveryMethod();
        var toFieldItem = form.getClickItemSelected('toField');
        var isFaxableContact = (deliveryType === 'fax') ||
                               (deliveryType === 'passport' && toFieldItem && (toFieldItem.access_practice_fax || toFieldItem.fax));
        var supportsPassport = toFieldItem;
        if (isFaxableContact) {
            // if we could fax this whole doc, we can show the chop-or-not checkbox
            if (supportsPassport && faxablePageCount) {
                $('.fax-attachments-section', container).show();
            } else {
                $('.fax-attachments-section', container).hide();
            }
            // we can't send by fax: disallow sending entirely
            if (!supportsPassport && !faxablePageCount) {
                form.disableButton('sign-primary');
            }
        } else {
            $('.fax-attachments-section', container).hide();
        }

        el8.appchart.mgr.thirdpane.adjustSize(); // we just changed the size of the options bar
    }
    /**
     * if the require-receipt checkbox changes, we need to deal with notification alerts
     */
    function setupIncludeAttachmentsCheckboxListener() {
        $(document).on('change', '.include-attachments-check', function() {
            syncIncludeAttachmentsCheckbox();
        });
    }

    /**
      * update the state of the require receipt checkbox based on the UI state
      */
    function syncIncludeAttachmentsCheckbox() {
        if (curLetter.isSendToPatient()) {
            return;
        }
        var isFaxAttachment = curLetter.isFaxAttachments();
        var faxSectionVisible = $('.fax-attachments-section', container).is(':visible');
        if (faxSectionVisible) {
            isFaxAttachment = form.getOptionCheckboxVal('includeAttachments');
        }

        var isPrinted = (curLetter.getDeliveryMethod() === 'printed' || !curLetter.getDeliveryMethod());

        if (isFaxAttachment || isPrinted) {
            // if faxing attachment or printing the letter, alert doesnt apply
            curLetter.setUnreadAlertDisabled(true);
            form.setVal('unreadAlertInDays', 'none', true);
            $('.unread-alert-in-days-selection').prop('disabled', true);
            $('.unread-alert-date-picker').prop('disabled', true);
        } else {
            curLetter.setUnreadAlertDisabled(false);
            $('.unread-alert-in-days-selection').prop('disabled', false);
            $('.unread-alert-date-picker').prop('disabled', false);

            // when unread alert UI is re-enabled, we should pull the user default again
            // because we dont want to leave it as "dont notify me"
            setDefaultUnreadNotificationFromUserPreference(curLetter.getLetterType());
            setUnreadAlert();

        }
        syncUnreadNotificationUIState();
    }


    function isAlertBySpecificDate(unreadAlertInDaysStr) {
        return unreadAlertInDaysStr === 'specificDate';
    }

    function isAlertDisabled(unreadAlertInDaysStr) {
        return unreadAlertInDaysStr === 'none';
    }

    function syncUnreadNotificationUIState() {
        // whats the current value
        var unreadAlertInDaysStr = form.getVal('unreadAlertInDays');

        $('.unread-alert-date-picker').hide();
        $('.unread-notification-date-label').hide();

        if (isAlertBySpecificDate(unreadAlertInDaysStr)) {
            $('.unread-alert-date-picker').show();

        } else if (isAlertDisabled(unreadAlertInDaysStr)) {
            // disabled (dont notify me)
            form.setVal('unreadAlertDate', '');
        } else {
            // in days
            // calculate the time difference
            form.setVal('unreadAlertDate', '');

            var unreadAlertInDays = unreadAlertInDaysStr*1;
            var deliveryDateTz = form.getVal('deliveryDate')? el8.service.tz.toTzDate(form.getVal('deliveryDate')) : null;
            var expectedAlertDateTz = daysInFuture(deliveryDateTz, unreadAlertInDays);
            var fromDateStr = deliveryDateTz? deliveryDateTz.asStringFormat('mm/dd') : 'today';
            $('.unread-notification-date-label').text(unreadAlertInDays + ' days from ' + fromDateStr + ': ' + expectedAlertDateTz.asStringFormat('mm/dd/yy'));
            $('.unread-notification-date-label').show();
        }
    }

    function daysInFuture(baseDateTz, numDays) {
       // calculate days in future
       // if baseDateTz is empty, use today
       var baseDateUsedTz = baseDateTz? el8.service.tz.newTzDate(baseDateTz) : el8.service.tz.today();
       return baseDateUsedTz.addDays(numDays*1);
    }

    function getCurrentAlertNotificationDate() {
        // get the current alert notification date
        // this works if you are using N days from today or with a set date
        var unreadAlertInDaysStr = form.getVal('unreadAlertInDays');

        if (isAlertBySpecificDate(unreadAlertInDaysStr)) {
            return form.getVal('unreadAlertDate')? el8.service.tz.toTzDate(form.getVal('unreadAlertDate')) : null;
        }

        if (!isAlertDisabled(unreadAlertInDaysStr)) {
            var unreadAlertInDays = unreadAlertInDaysStr*1;
            if (unreadAlertInDays > 0) {
                var deliveryDateTz = form.getVal('deliveryDate')? el8.service.tz.toTzDate(form.getVal('deliveryDate')) : null;
                return daysInFuture(deliveryDateTz, unreadAlertInDays);
            }
        }
        return null;
    }

    // show alerts when post date and alert date conflict
    function alertIfPostDateAndAlertDateConflict() {
        // need to get the calculated dates
        var deliveryDateTz = form.getVal('deliveryDate')? el8.service.tz.toTzDate(form.getVal('deliveryDate')) : null;
        var unreadAlertDateTz = getCurrentAlertNotificationDate(form);

        if (unreadAlertDateTz && deliveryDateTz) {
            if (el8.util.datecompare.cmp(deliveryDateTz, unreadAlertDateTz) >= 0) {
                el8.uiwidget.alert('Post date must be before the unread notification date.');
                form.setVal('deliveryDate', '');
            }
        }
    }


    function nagIfRawFax() {
        if (!curLetter.isSendToPatient() && curLetter.getFaxTo()) {
            el8.appchart.letters.rawFaxNag.show({
                anchor: form.getInputField('toField').first(),
                appendElt: content,
                faxNum: curLetter.getFaxTo(),
                callbackFn: newContactCb
            });
        } else {
            el8.appchart.letters.rawFaxNag.hideIfShowing();
        }
    }

    /* Sub-section of rendering logic for attachments
     */
    function highlightAttachments(ids) {
        var $list = $('.attachments-list', container);
        for (var i=0; i<ids.length; i++) {
            $('.attachment-item[data-id="'+ids[i]+'"]', $list).addClass('el8Highlight');
        }
        $.el8_setTimeout(function() {
            unhighlightAttachments(ids);
        }, 10*1000); // highlight for 10 seconds
    }
    function unhighlightAttachments(ids) {
        var $list = $('.attachments-list', container);
        for (var i=0; i<ids.length; i++) {
            $('.attachment-item[data-id="'+ids[i]+'"]', $list).removeClass('el8Highlight');
        }
    }
    function renderAttachments(isCreate) {
        $('.attachments-list', container).html(
            el8.template.appchart.letters.attachmentList({
                attachments: curLetter.getAttachments().map(el8.model.toSoyMapFn)
            })
        );
        if (curLetter.getAttachments().length < el8.util.consts.EL8_DOWNLOAD_ONLY_PAGES) {
            curLetter.getAttachmentPageCounts(renderAttachmentCounts);
        } else {
            skipRenderingAttachmentCounts();
        }

        // creating, set the checkbox to isFaxAttachments from the defaultFaxAttachments feature flag
        if (isCreate) {
            form.setOptionCheckboxVal('includeAttachments', curLetter.isFaxAttachments());
        }

        // Automatically check off the "Also fax copies of the attachments" checkbox in the letter if
        // there is only 1 attachment included and the attachment is an order form (labs, imaging,
        // cardiac, sleep, pulmonary) OR a visit note

        // ONLY with 1 attachment. If the user removed to 0 or added to 2, do nothing to the checkbox
        // as to not override either the users orignal intent via the flag or any subsequent decision
        if (curLetter.getAttachments().length === 1) {
            var attach = curLetter.getAttachments()[0];
            var modelClass = el8.model.idToModelClass(attach.getEntityId());

            if (_.contains(['VisitNote',
                            'ReferralOrder',
                            'LabOrder',
                            'ImagingOrder',
                            'CardiacOrder',
                            'PulmonaryOrder',
                            'SleepOrder'], modelClass)) {
                form.setOptionCheckboxVal('includeAttachments', true);
            }
        }
    }
    function renderAttachmentCounts(data) {
        // Remove the whole thing from the DOM, update all the counts, and then re-insert
        // to avoid repeatedly repainting / redoing layout
        var $attachmentsHtml = $('.attachments-list', container).contents();
        $('.attachments-list', container).empty();
        for (var key in data) {
            if (data.hasOwnProperty(key) && key !== 'total_pages') {
                var text = el8.template.ptdata.letters.attachments.pageCountShort({count: data[key]});
                $attachmentsHtml.find('.page-count[data-id="'+key+'"]').text(text);
            }
        }
        $('.attachments-list', container).html($attachmentsHtml);
        var totalText = el8.template.ptdata.letters.attachments.pageCountFull({
            count: data.total_pages,
            UPPER_BOUND: el8.util.consts.EL8_DOWNLOAD_ONLY_PAGES
        });
        $('.total-page-count', container).text(totalText);
        totalPageCount = data.total_pages;

        updateDeliveryDescription();
        updateActions();
    }
    function skipRenderingAttachmentCounts() {
        // Do this when the we have so many attachments that we don't care about individual counts anymore
        var $attachmentsHtml = $('.attachments-list', container).contents();
        $('.page-count', $attachmentsHtml).empty();

        var totalText = el8.template.ptdata.letters.attachments.pageCountFull({
            count: el8.util.consts.EL8_DOWNLOAD_ONLY_PAGES,
            UPPER_BOUND: el8.util.consts.EL8_DOWNLOAD_ONLY_PAGES
        });
        $('.total-page-count', container).text(totalText);
        totalPageCount = el8.util.consts.EL8_DOWNLOAD_ONLY_PAGES;

        updateDeliveryDescription();
        updateActions();
    }
    /* end display managers */


    return that;

})();
